// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38-rb","question":"styles_question__2G2bS","description":"styles_description__1uMY4"};